import { Directive, ElementRef, NgZone, OnDestroy, OnInit } from '@angular/core';

@Directive({
  selector: '[uiTouchFeedback]',
  standalone: true,
})
export class UiTouchFeedbackDirective implements OnInit, OnDestroy {
  private el: HTMLElement;
  private onTouchStart = () => {
    this.el.classList.add('is-pressed');
    this.el.style.background = 'var(--color-mobile-nav-hover)';
  };
  private onTouchEnd = () => {
    this.el.classList.remove('is-pressed');
    this.el.style.background = '';
  };

  constructor(elRef: ElementRef<HTMLElement>, private zone: NgZone) {
    this.el = elRef.nativeElement;
  }

  ngOnInit(): void {
    this.zone.runOutsideAngular(() => {
      this.el.addEventListener('touchstart', this.onTouchStart, {
        passive: true,
      });
      this.el.addEventListener('touchend', this.onTouchEnd, {
        passive: true,
      });
      this.el.addEventListener('touchcancel', this.onTouchEnd, {
        passive: true,
      });
    });
  }

  ngOnDestroy(): void {
    this.el.removeEventListener('touchstart', this.onTouchStart);
    this.el.removeEventListener('touchend', this.onTouchEnd);
    this.el.removeEventListener('touchcancel', this.onTouchEnd);
  }
}
